import { render } from "./RoleManage.vue?vue&type=template&id=019e15dd&scoped=true"
import script from "./RoleManage.vue?vue&type=script&lang=js"
export * from "./RoleManage.vue?vue&type=script&lang=js"

import "./RoleManage.vue?vue&type=style&index=0&id=019e15dd&scoped=true&lang=css"

import exportComponent from "/Users/tandongling/Documents/vue/vue-argon-dashboard-2-pro-v3.0.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019e15dd"]])

export default __exports__